import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success, ROUTES } from '../../shared/constants'

export const useDashBoard = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [loading, setLoading] = useState(true)
  const [leadDashBoard, setLeadDashBoard] = useState(false)
  const [attendanceDashBoard, setAttendanceDashBoard] = useState(false)
  const [salesDashBoard, setSalesDashBoard] = useState(false)
  const [leaveDashBoard, setLeaveDashBoard] = useState(false)
  const [homeDashBoard, setHomeDashBoard] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState(false)

  const getLeadDashBoard = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_LEAD_DASHBOARD(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setLeadDashBoard(data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getHomeDashBoard = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_HOME_DASHBOARD(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setHomeDashBoard(data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getLeaveDashBoard = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_LEAVE_DASHBOARD(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setLeaveDashBoard(data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAttendanceDashBoard = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ATTENDANCE_DASHBOARD(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setAttendanceDashBoard(data)
        setLoading(false)
        // if (status !== 200) {
        //     return toastMessage('Something Went Wrong !', error)
        // }

        //console.log('DATA : ', data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  const getSalesDashBoard = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_SALES_DASHBOARD(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setSalesDashBoard(data)
        setLoading(false)
        // if (status !== 200) {
        //     return toastMessage('Something Went Wrong !', error)
        // }

        //console.log('DATA : ', data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  const getCsvPdfData = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_CSV_PDF_DATA(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setPdfCsvData(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    getLeadDashBoard,
    getLeaveDashBoard,
    getHomeDashBoard,
    getAttendanceDashBoard,
    leadDashBoard,
    leaveDashBoard,
    homeDashBoard,
    attendanceDashBoard,
    loading,
    pdfCsvData,
    getCsvPdfData,
    getSalesDashBoard,
    salesDashBoard,
  }
}
